import React from 'react';
import { Modal, Box, Button, Typography } from '@mui/material';

const styles = theme => ({
    position: 'absolute',
    top: '3em',
    left: '10%',
    width: '80%',
    [theme.breakpoints.up('md')]: {
      left: '30%',
      width: '40%'
    },
    backgroundColor: theme.palette.background.paper,
    boxShadow: 5,
    padding: 4,
    textAlign: 'center',
    maxHeight: '80%',
    overflow: 'scroll'
});

export class InputExampleModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      tab: 0
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    this.setState({open: true});
  }

  handleClose() {
    this.setState({open: false});
  }

  render() {
    const { buttonLabel, image, text } = this.props;
    const { open, tab } = this.state;

    return (
      <React.Fragment>
        <Button onClick={this.handleOpen} color="inherit" className='select-artwork'>{buttonLabel}</Button>
        <Modal open={open} onClose={this.handleClose}>
          <Box sx={styles}>
            {image &&
              <img src={image} style={{maxWidth: '75%'}} alt="Example illustration image" />
            }
            {text &&
              <Typography style={{marginTop: '1em', marginBottom: '1em'}}>{text}</Typography>
            }
            <div style={{marginTop: '10px'}}>
              <Button variant="contained" onClick={this.handleClose}>Ok</Button>
            </div>
          </Box>
        </Modal>
      </React.Fragment>
    );
  }
}

export default InputExampleModal;
